theme.accordion = (function() {
  // faq-new panels open with .d-block. slideDown measures offsetHeight while
  // the panel is collapsed, which stays 0, and the stylesheet max-height
  // uses !important so that inline height never wins.
  function isNewFaq(body) {
    return body && body.classList.contains('faq-new__accordion-body');
  }

  function openBody(body) {
    if (!body) return;
    if (isNewFaq(body)) {
      body.classList.add('d-block');
      return;
    }
    slideDown(body);
  }

  function closeBody(body) {
    if (!body) return;
    if (isNewFaq(body)) {
      body.classList.remove('d-block');
      return;
    }
    slideUp(body);
  }

  function accordionBody(e) { 
    let faqContainer = e.querySelectorAll('.faq__list--item__button');
    faqContainer.forEach(function (list) {
      list.addEventListener("click", function (event) {
          let singleFaqItem = list.closest('.faq__list--item, .faq-new__accordion-item'),
              singleFaqItemBody = singleFaqItem.querySelector('.faq__body');
        
       		singleFaqItem.addEventListener(
                  "transitionend",
                  () => {
                    trapFocus(singleFaqItem);
                  },
                  { once: true }
             );
      
      		singleFaqItem.addEventListener("keyup", (evt) => {
              if (evt.code === "Escape") {
                singleFaqItem.classList.remove("active");
                closeBody(singleFaqItemBody);
                removeTrapFocus(singleFaqItem);
                // Update aria-expanded for accessibility
                list.setAttribute('aria-expanded', 'false');
              }
            });
        
          if (singleFaqItem.classList.contains("active")) {
            singleFaqItem.classList.remove("active");
            closeBody(singleFaqItemBody);
            // Update aria-expanded for accessibility
            list.setAttribute('aria-expanded', 'false');
          } else {
            singleFaqItem.classList.add("active");
            openBody(singleFaqItemBody);
            // Update aria-expanded for accessibility
            list.setAttribute('aria-expanded', 'true');
            getSiblings(singleFaqItem).forEach(function (sibling) {
              if (!sibling.classList.contains('faq__list--item') && !sibling.classList.contains('faq-new__accordion-item')) {
                return;
              }
              let sibllingSingleAccordionBody = sibling.querySelector('.faq__body');
              sibling.classList.remove("active");
              closeBody(sibllingSingleAccordionBody);
              // Update aria-expanded for sibling buttons
              let siblingButton = sibling.querySelector('.faq__list--item__button');
              if (siblingButton) {
                siblingButton.setAttribute('aria-expanded', 'false');
              }
            });
          }
      });
      
    });
  }
  return accordionBody;
})();
